import { ruleDefinitionDefaults, defaultValidationTagRule, createValidator } from './TagRulesCommon'


const ruleDefinition =
{
    ...ruleDefinitionDefaults,
    ruleType: "TagProductsByVariantOption",
    title: "Auto Tag Products By Variant Option",
    description: "Automatically tag products with values from a specified variant option.",
    example: "Selecting the Size option for a clothing item will add the values for Size from all variants as tags. For example S, XL, XXL.",
    additional: [
        "Products/variants that do not have the selected option will not be affected if the AutoRemoveTags option is not enabled.",
        "Use the \"Auto Remove Tags\" option if you want to remove existing tags when ",
        "Products with more that one variant can be ignored by using the filter section below.",
    ],
    legacy: false,
    inProgress: false,
    previewType: "ProductTags",
    tags: ["Products", "Variants", "Tags"],
    getDefaultRuleState: () => {
        return {
            name: null,
            trigger: "Automatic",
            settings: {
                ruleTypeId: "TagProductsByVariantOption",
                optionName: "",
                valueTemplate: {
                    prefix: null,
                    suffix: null,
                    casingTransformation: "KeepOriginal",
                    spacesTransformation: "KeepSpaces",
                },
                skipTagsIfQuantityIsZero: false,
                removeTagsIfQuantityIsZero: false,
            }
        }
    },
    createValidator: (onAsyncError) => {
        return createValidator(
            onAsyncError,
            [defaultValidationTagRule,
                (rule, errors) => {
                    if (rule.settings.optionName == null || rule.settings.optionName === "") {
                        errors["optionName"] = "Option name is required";
                    }
                }
            ], null);
    }
};

export default ruleDefinition;